export default function ($translate) {
    return {
        KEYS: {
            SAME_POINTS_TO_EVERY_LICENCE: 'SAME_POINTS_TO_EVERY_LICENCE',
            DIVIDE_POINTS_EQUALLY: 'DIVIDE_POINTS_EQUALLY'
        },
        LABELS: {
            SAME_POINTS_TO_EVERY_LICENCE: $translate.instant('licence.Same points to every licence'),
            DIVIDE_POINTS_EQUALLY: $translate.instant('licence.Divide points equally between licences')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/user/licence/pointAddingType/index.js